module.exports = __webpack_public_path__ + "img/imagemissing111.52e62467.jpg";